export const ELEMENT_TYPES = {
  TAG: "tag",
  TEXT: "text",
  COMMENT: "comment"
};

export const EMPTY_TAGS = {
  "area": 1,
  "base": 1,
  "basefont": 1,
  "br": 1,
  "col": 1,
  "frame": 1,
  "hr": 1,
  "img": 1,
  "input": 1,
  "isindex": 1,
  "link": 1,
  "meta": 1,
  "param": 1,
  "embed": 1
};

export const MODE_TYPES = {
  TEXT: 'text',
  TAG: 'tag',
  STYLE: 'style',
  SCRIPT: 'script'
};

export const TAG_TYPES = {
  EMPTY: 'empty',
  DEFAULT: 'default',
  SCRIPT: 'script',
  STYLE: 'style',
  COMMENT: 'comment'
};

export const QUOTE_TYPES = {
  SINGLE: 1,
  DOUBLE: 2
};